// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ezawwuctrsmhmmomcgtw.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV6YXd3dWN0cnNtaG1tb21jZ3R3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk1MzU0ODUsImV4cCI6MjA3NTExMTQ4NX0.BOUI1PeX32ArqxO0MZr8QCaAZpG23S_vrwq62qXZaO8';

// ✅ CRITICAL FIX: Add auth options to persist sessions
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,        // ✅ Store session in localStorage
    autoRefreshToken: true,      // ✅ Auto-refresh expired tokens
    detectSessionInUrl: true,    // ✅ Detect session from URL params
    storage: window.localStorage, // ✅ Use localStorage explicitly
    storageKey: 'supabase.auth.token', // ✅ Storage key name
  },
});

// ✅ Add debugging to see auth events
supabase.auth.onAuthStateChange((event, session) => {
  console.log('🔐 Supabase auth event:', event);
  if (session) {
    console.log('✅ Session active, token:', session.access_token ? 'Present' : 'Missing');
  } else {
    console.log('⚠️ No active session');
  }
});

export default supabase;